import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import { TableCell, TableRow } from 'transfix-ui/components/Table'
import { capitalize } from 'utils/capitalize'
import { TItem } from '../../../types'

interface IShipperTableRowProps {
  shipper: TItem
}

export const ShipperTableRow = memo<IShipperTableRowProps>(({ shipper }) => {
  const { id, name = '', shipmentEmail = '', state = '' } = shipper || {}

  return (
    <TableRow dataTest='shipper-table-row'>
      <TableCell dataTest='shipper-table-row-name'>
        <Link to={`/shippers/${id}`}>{name}</Link>
      </TableCell>
      <TableCell dataTest='shipper-table-row-email'>
        <a href={`mailto:${shipmentEmail}`}>{shipmentEmail}</a>
      </TableCell>
      <TableCell dataTest='shipper-table-row-state'>{capitalize(state)}</TableCell>
    </TableRow>
  )
})

export default ShipperTableRow
